import { render, staticRenderFns } from "./PEC_text.vue?vue&type=template&id=08b68763"
import script from "./PEC_text.vue?vue&type=script&lang=js"
export * from "./PEC_text.vue?vue&type=script&lang=js"
import style0 from "./PEC_text.vue?vue&type=style&index=0&id=08b68763&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports